import * as Sentry from '@sentry/react';
import settings from 'config/settings';

export default function startup() {
  // Without a DSN Sentry would only create a client that sends nothing, so it is not initialised at all.
  if (!settings.isProduction || !settings.dsn) return;

  Sentry.init({
    dsn: settings.dsn,
    // Sentry 5 sent no release health sessions; the session integration Sentry 11 adds to its defaults stays off.
    integrations: (defaultIntegrations) =>
      defaultIntegrations.filter((integration) => integration.name !== 'BrowserSession'),
    ignoreErrors: [
      "Cannot read property 'readyState' of null",
      "null is not an object (evaluating 'g.readyState')",
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications.',
      'fbq is not defined',
      'XMLHttpRequest.g.onreadystatechange(analytics)',
      /analytics/,
      /fbq/,
    ],
  });
}
